module.exports = __webpack_public_path__ + "img/capsules-solid.283a97b4.svg";